import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { LocaleProvider } from ":shared/lib/locale";
import { SUPPORTED_LOCALES, type SupportedLocale } from ":shared/lib/i18n";

export const Route = createFileRoute("/$locale")({
	beforeLoad: ({ params }) => {
		const { locale } = params;

		if (!SUPPORTED_LOCALES.includes(locale as SupportedLocale)) {
			throw redirect({
				to: "/en/dashboard",
				throw: true,
			});
		}
	},
	component: LocaleLayoutComponent,
});

function LocaleLayoutComponent() {
	const { locale } = Route.useParams();

	return (
		<LocaleProvider locale={locale as SupportedLocale}>
			<Outlet />
		</LocaleProvider>
	);
}
